export {
  entityFactory,
  boundaryFactory,
  getEntityClasses
} from './entity/factory'
export { Entity } from './entity/Entity'
export { Laboratory } from './entity/Laboratory'
export { Campus } from './entity/Campus'
